// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"237e6b02","174":"70d3cc82","215":"3ad89691","436":"4ede03e1","522":"4323a4d7","570":"eba96dbc","601":"a0eb3887","608":"1ede5b5b","652":"80ea974a","684":"4d921821","687":"2342877f","781":"f77249f3","812":"3bc94820","988":"bd363d05"}[chunkId] + ".js";
};